module.exports = __webpack_public_path__ + "static/media/search.93d87dec.svg";